<template>
  <md-dialog v-bind="$attrs" v-on="$listeners" :md-fullscreen="false">
    <div class="barcode-viewport-container">
      <div class="viewport">
        <md-toolbar md-elevation="1">
          <h2 class="md-title">Oбновить данные</h2>
        </md-toolbar>
        <div>
          <barcode
            tag="img"
            value="serv_000000005"
            :options="{ displayValue: false, format: 'CODE128' }"
          ></barcode>
        </div>
      </div>
      <div class="viewport">
        <md-toolbar md-elevation="1">
          <span class="md-title">Печать мешка</span>
        </md-toolbar>
        <div>
          <barcode
            tag="img"
            value="serv_000000006"
            :options="{ displayValue: false, format: 'CODE128' }"
          ></barcode>
        </div>
      </div>
    </div>

    <md-dialog-actions>
      <md-button class="md-primary" @click="$emit('update:mdActive', false)">
        {{ mdConfirmText }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
  export default {
    name: "MdDialogAlertBarcode",
    props: {
      mdConfirmText: {
        type: String,
        default: "Ok",
      },
    },
  };
</script>

<style lang="scss">
  .barcode-viewport-container {
    display: flex;
    flex-direction: column;
    padding: 12px;
    gap: 48px;
    @media (orientation: landscape) {
      flex-direction: row;
      width: 600px;
    }
  }
</style>
